export enum DermloopSksCodeType {
  // Diagnosis code
  DIA = 'dia',
  // Tillægskode
  TIL = 'til',
}
